import { render, staticRenderFns } from "./DSAlertIcon.vue?vue&type=template&id=803997e0&"
import script from "./DSAlertIcon.vue?vue&type=script&lang=js&"
export * from "./DSAlertIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports